import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import api from '../../core/api';
import {CircularProgress} from '@material-ui/core';
import CouponForm from '../../components/forms/CouponForm';

const EditCoupon = ({history, match}) => {
  const [loading, setLoading] = useState(false);
  const [coupon, setCoupon] = useState({});

  const fetchCoupon = async () => {
    setLoading(true);
    try {
      const {data: coupon} = await api.get(`/coupons/${match.params.cuponId}`);
      let coupomInitial = coupon;
      if (coupon?.business_coupons.length > 0)
        coupomInitial = {
          ...coupomInitial,
          businesses: coupon.business_coupons.map(b => b.business),
        };
      setCoupon(coupomInitial);
      console.log('coupon to edit', coupomInitial);
    } catch (e) {
      console.log('Error fetching coupon', e);
      alert(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoupon();
  }, []);

  return (
    <Dashboard>
      {!loading && coupon.id ? (
        <CouponForm history={history} coupon={coupon} />
      ) : (
        <div className="flex-col center-a center-b" style={{height: '50vh'}}>
          <CircularProgress size={100} />
          <p> Carregando... </p>
        </div>
      )}
    </Dashboard>
  );
};

export default EditCoupon;
